import React from "react";
import useDepartmentDoctors from "../hooks/useDepartmentDoctors";
import DoctorCard from "./DoctorCard";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";
import SEO from "../pages/SEO"
import { useAppointment } from "../context/AppointmentContext"
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

import {
  Activity,
  Stethoscope,
  Users,
  Shield,
  Award,
  Clock,
  Phone,
  Mail,
  MapPin,
  Check,
  Calendar,
  ArrowRight,
  Heart,
  Microscope,
} from "lucide-react";

export default function UrologyPage() {
  const { open: openAppointment } = useAppointment();
  const doctors = useDepartmentDoctors("Urology");


  
  const subspecialties = [
    {
      title: "Endourology",
      icon: <Microscope className="h-6 w-6 text-apple-teal" />,
      description: "Laser treatment for kidney and ureteric stones.",
      image: "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/04/Endourology-scaled.jpg",
    },
    {
      title: "Andrology",
      icon: <Users className="h-6 w-6 text-apple-teal" />,
      description: "Male infertility and sexual health management.",
      image: "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/04/Andrology-scaled.jpg",
    },
    {
      title: "Uro-Oncology",
      icon: <Shield className="h-6 w-6 text-apple-teal" />,
      description: "Cancer care for bladder, kidney, and prostate.",
      image: "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/04/Uro-Oncology-scaled.jpg",
    },
    {
      title: "Female Urology",
      icon: <Heart className="h-6 w-6 text-apple-teal" />,
      description: "Treatment for urinary incontinence and infections.",
      image: "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/04/Female-Urology-scaled.jpg",
    },
    {
      title: "Reconstructive Urology",
      icon: <Activity className="h-6 w-6 text-apple-teal" />,
      description: "Surgical repair for structural urinary issues.",
      image: "https://mamshospitals.mamscollege.com/wp-content/uploads/2026/04/Reconstructive-Urology-scaled.jpg",
    },
    {
      title: "Pediatric Urology",
      icon: <Stethoscope className="h-6 w-6 text-apple-teal" />,
      description: "Care for congenital urinary tract disorders in children.",
      image: "/PediatricUrology.jpg",
    },
  ];

  const procedures = [
    "Laser Stone Removal (PCNL, URS, RIRS)",
    "Prostate Surgery (TURP, Laser Enucleation)",
    "Urethral Stricture Repair",
    "Bladder Cancer Surgery",
    "Male Infertility Treatments",
    "Kidney & Ureteral Stone Management",
  ];

  const whyChoose = [
    {
      icon: <Activity className="h-8 w-8 text-apple-teal" />,
      title: "Advanced Technology",
      description:
        "State-of-the-art laser and endoscopic equipment for precise treatment.",
    },
    {
      icon: <Users className="h-8 w-8 text-apple-teal" />,
      title: "Expert Urologists",
      description:
        "Experienced specialists with high success rates in complex procedures.",
    },
    {
      icon: <Clock className="h-8 w-8 text-apple-teal" />,
      title: "24x7 Emergency Care",
      description: "Round-the-clock kidney stone and urinary emergency services.",
    },
    {
      icon: <Award className="h-8 w-8 text-apple-teal" />,
      title: "Minimally Invasive",
      description:
        "Day-care surgeries with faster recovery and minimal pain.",
    },
    {
      icon: <MapPin className="h-8 w-8 text-apple-teal" />,
      title: "Convenient Location",
      description:
        "Easy access near Miyapur & Bachupally for quick consultation.",
    },
  ];

  const articles = [
    {
      icon: <Activity className="h-6 w-6 text-apple-teal" />,
      title: "Top 5 Causes of Kidney Stones and How to Prevent Them",
      description:
        "Learn about dietary and lifestyle factors that contribute to stone formation.",
    },
    {
      icon: <Users className="h-6 w-6 text-apple-teal" />,
      title: "Understanding Prostate Health After 40",
      description:
        "Important information for maintaining urological wellness as you age.",
    },
    {
      icon: <Microscope className="h-6 w-6 text-apple-teal" />,
      title: "Advanced Laser Treatments in Urology",
      description:
        "Explore modern minimally invasive techniques for urological conditions.",
    },
    {
      icon: <Heart className="h-6 w-6 text-apple-teal" />,
      title: "Hydration Tips for Healthy Kidneys",
      description:
        "Simple habits to maintain optimal kidney function and prevent stones.",
    },
  ];

  const faqs = [
    {
      question: "Do you offer laser treatment for kidney stones?",
      answer:
        "Yes, our hospital provides advanced laser and endoscopic stone removal with minimal recovery time.",
    },
    {
      question: "Is prostate surgery painful?",
      answer:
        "Modern laser surgeries are minimally invasive and nearly painless with faster recovery compared to traditional methods.",
    },
    {
      question: "Do you provide male infertility treatments?",
      answer:
        "Yes, our Andrology unit offers specialized diagnostic and treatment services for male infertility.",
    },
  ];
  const schema = [
  {
    "@context": "https://schema.org",
    "@type": "MedicalClinic",
    "name": "MAMS Hospitals Urology Department",
    "url": "https://mamshospitals.com/urology",
    "logo": "https://mamshospitals.com/MAMS-Logo.png",
    "image": "https://mamshospitals.com/Urology.jpg",
    "description": "MAMS Hospitals provides advanced urology treatment in Hyderabad including kidney stone treatment, prostate surgery, laser urology procedures, uro-oncology, and male infertility treatment.",
    "medicalSpecialty": "Urology",
    "telephone": "+91-7399999981",
    "priceRange": "$$",

    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Bachupally",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "postalCode": "500090",
      "addressCountry": "IN"
    },

    "availableService": [
      {
        "@type": "MedicalProcedure",
        "name": "Laser Kidney Stone Removal"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Prostate Surgery"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Male Infertility Treatment"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Bladder Cancer Surgery"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Urethral Stricture Repair"
      }
    ],

    "sameAs": [
      "https://www.facebook.com/MAMSHospitals",
      "https://www.instagram.com/mams_hospitals"
    ]
  },

  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Do you offer laser treatment for kidney stones?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, MAMS Hospitals provides advanced laser and endoscopic kidney stone removal procedures with faster recovery."
        }
      },
      {
        "@type": "Question",
        "name": "Do you provide prostate surgery?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, MAMS Hospitals offers minimally invasive prostate surgeries and laser treatments."
        }
      },
      {
        "@type": "Question",
        "name": "Do you provide male infertility treatment?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, our andrology department offers specialized treatment for male infertility and reproductive health."
        }
      }
    ]
  },

  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Urology Department - MAMS Hospitals",
    "url": "https://mamshospitals.com/urology",
    "description": "Best urology hospital in Hyderabad offering kidney stone treatment, prostate surgery, laser urology, uro-oncology, and male infertility treatment.",
    "keywords": [
      "Urology Hospital Hyderabad",
      "Best Urologist Hyderabad",
      "Kidney Stone Treatment Hyderabad",
      "Laser Stone Surgery Hyderabad",
      "Prostate Surgery Hyderabad",
      "Male Infertility Treatment Hyderabad",
      "Urology Hospital Bachupally"
    ]
  }
  ];
  return (
    <>
    <SEO
    title="Best Urology Hospital in Hyderabad | Kidney Stone & Prostate Care | MAMS Hospitals"
  description="MAMS Hospitals offers advanced urology treatment in Hyderabad including kidney stone removal, prostate surgery, laser urology, uro-oncology, and male infertility treatment."
  keywords="urology hospital Hyderabad,
  best urologist Hyderabad,
  kidney stone treatment Hyderabad,
  laser stone surgery Hyderabad,
  prostate surgery Hyderabad,
  male infertility treatment Hyderabad,
  uro-oncology Hyderabad,
  laser urology Hyderabad,
  kidney specialist Hyderabad,
  urology hospital Bachupally,
  kidney stone removal Hyderabad,
  andrology specialist Hyderabad,
  MAMS Hospitals Urology"
    schema={schema}
  />

    <div className="flex flex-col min-h-screen">
      {/* HERO SECTION */}
      <section className="relative bg-gradient-to-b from-apple-teal/10 to-white py-12 md:py-24">
        <div className="container mx-auto px-0 max-w-6xl grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-apple-teal/10 px-4 py-2 rounded-full mb-6">
              <Activity className="h-5 w-5 text-apple-teal" />
              <span className="text-apple-teal font-medium">
                Best Urology Hospital in Hyderabad
              </span>
            </div>

            <h1 className="text-3xl md:text-5xl font-bold text-apple-gray-500 mb-6">
              Complete Urological Care
            </h1>

            <p className="text-lg text-apple-gray-400 mb-8">
              MAMS Hospitals is one of the Best Urology Hospitals in Hyderabad,
              providing complete care for urinary tract, kidney, and male
              reproductive health.
            </p>

           <div className="flex flex-col sm:flex-row gap-4">

                <Button className="bg-teal-600 hover:bg-teal-700 text-white rounded-full px-8" size="lg" onClick={openAppointment}>
                    Book Appointment
                  </Button>

                <Link to="tel:+91-7399999981">
                  <Button
                    className="border-teal-600 text-teal-600 hover:bg-teal-50 rounded-full px-8"
                    variant="outline"
                    size="lg"
                  >
                    <Phone className="mr-2 h-5 w-5" />
                    Call Us
                  </Button>
                </Link>

              </div>
          </div>

          <div className="relative mt-8 md:mt-0">
            <img
              src="/Urology.jpg"
              alt="Urology Care"
              className="rounded-3xl shadow-2xl w-full"
            canonicalUrl="https://mamshospitals.com/departments/urology"
      />
            <div className="absolute -bottom-4 left-2 sm:-bottom-6 sm:-left-6 bg-white p-3 sm:p-6 rounded-2xl shadow-lg">
              <div className="flex items-center gap-4">
                <div className="bg-green-100 p-3 rounded-full">
                  <Microscope className="h-6 w-6 text-green-600" />
                </div>
                <div>
                  <div className="text-2xl font-bold text-apple-gray-500">
                    Advanced
                  </div>
                  <div className="text-sm text-apple-gray-400">
                    Laser Treatment
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SUB-SPECIALTIES */}
      <section className="py-16 px-0 bg-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-semibold text-apple-gray-500 mb-4">
              Sub-Specialties in Urology
            </h2>
            <p className="text-apple-gray-400 max-w-2xl mx-auto">
              Comprehensive urological care with advanced treatment options
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {subspecialties.map((service, index) => (
              <Card
                key={index}
                className="border-apple-gray-100 hover:border-apple-teal transition-all duration-300 hover:shadow-lg rounded-3xl overflow-hidden group"
              >
                <div className="aspect-video bg-apple-gray-50 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition"
                  />
                </div>
                <CardContent className="p-6">
                  <div className="bg-apple-teal/10 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                    {service.icon}
                  </div>
                  <h3 className="text-xl font-semibold text-apple-gray-500 mb-2">
                    {service.title}
                  </h3>
                  <p className="text-apple-gray-400 text-sm">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* TREATMENTS & PROCEDURES */}
      <section className="py-16 px-0 bg-apple-gray-50">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-semibold text-apple-gray-500 mb-4">
              Treatments & Procedures
            </h2>
            <p className="text-apple-gray-400 max-w-2xl mx-auto">
              Advanced urological procedures with proven success rates
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-4 mb-8">
            {procedures.map((procedure, index) => (
              <Card key={index} className="border-apple-gray-100 rounded-2xl">
                <CardContent className="p-4 flex items-center gap-3">
                  <div className="bg-apple-teal/10 p-2 rounded-full">
                    <Check className="h-5 w-5 text-apple-teal" />
                  </div>
                  <p className="text-apple-gray-500 font-medium">{procedure}</p>
                </CardContent>
              </Card>
            ))}
          </div>

          <Card className="border-apple-teal/30 bg-gradient-to-r from-apple-teal/10 rounded-3xl">
            <CardContent className="p-8 flex gap-4">
              <div className="bg-apple-teal/20 p-3 rounded-full">
                <Activity className="h-6 w-6 text-apple-teal" />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-apple-gray-500 mb-2">
                  Advanced Urological Services
                </h3>
                <p className="text-apple-gray-400">
                  From kidney stones to prostate care — minimally invasive
                  techniques and rapid recovery.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* WHY CHOOSE */}
      <section className="py-16 px-0 bg-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-semibold text-apple-gray-500 mb-4">
              Why Choose MAMS Hospitals for Urology Care
            </h2>
            <p className="text-apple-gray-400 max-w-2xl mx-auto">
              Excellence in urological care with cutting-edge technology
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {whyChoose.map((item, index) => (
              <Card
                key={index}
                className="border-apple-gray-100 hover:border-apple-teal transition-all rounded-3xl"
              >
                <CardContent className="p-6">
                  <div className="bg-apple-teal/10 p-3 rounded-full w-fit mb-4">
                    {item.icon}
                  </div>
                  <h3 className="text-xl font-semibold text-apple-gray-500 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-apple-gray-400">{item.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* SPECIALIST */}
                {doctors.length > 0 && (
          <section className="py-16 px-0 bg-apple-gray-50">
            <div className="container mx-auto max-w-6xl">
              <div className="text-center mb-12">
                <h2 className="text-3xl md:text-4xl font-semibold text-apple-gray-500 mb-4">Meet Our Specialists</h2>
              </div>
              <div className="relative">
                <button
                  onClick={() => { const el = document.getElementById('doc-scroll'); if(el) el.scrollBy({ left: -340, behavior: 'smooth' }); }}
                  className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md rounded-full p-2 hover:bg-gray-100"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
                </button>
                <div id="doc-scroll" className="flex gap-6 overflow-x-auto scroll-smooth px-10 scrollbar-hide pb-4">
                  {doctors.map(doctor => (
                    <div key={doctor.id} className="w-[280px] sm:w-[300px] flex-shrink-0">
                      <DoctorCard doctor={{
                        name: doctor.title.rendered,
                        slug: doctor.slug,
                        imageUrl: doctor._embedded?.["wp:featuredmedia"]?.[0]?.source_url || "",
                        specialty: doctor._embedded?.["wp:term"]?.[0]?.[0]?.name || "",
                        designation: doctor.acf?.designation || "",
                        qualification: doctor.acf?.qualification || "",
                        experience: doctor.acf?.experience || "",
                      }} />
                    </div>
                  ))}
                </div>
                <button
                  onClick={() => { const el = document.getElementById('doc-scroll'); if(el) el.scrollBy({ left: 340, behavior: 'smooth' }); }}
                  className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md rounded-full p-2 hover:bg-gray-100"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                </button>
              </div>
              <div className="text-center mt-8">
                <Link to="/doctors">
                  <button className="px-6 py-3 rounded-full border text-sm font-medium inline-flex items-center gap-2">
                    View All Doctors
                  </button>
                </Link>
              </div>
            </div>
          </section>
          )}
      {/* FAQ */}
      <section className="py-16 px-0 bg-apple-gray-50">
        <div className="container mx-auto max-w-4xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-semibold text-apple-gray-500">
              Frequently Asked Questions
            </h2>
          </div>

          <Accordion className="space-y-4" type="single" collapsible>
            {faqs.map((faq, index) => (
              <AccordionItem
                value={`faq-${index}`}
                key={index}
                className="border rounded-2xl bg-white px-6"
              >
                <AccordionTrigger className="text-left py-4">
                  <span className="font-semibold text-apple-gray-500">
                    {faq.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-apple-gray-400 pb-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

       {/* Contact & Appointment Section */}
      <section className="py-16 px-0 bg-apple-teal text-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-semibold mb-4">Book an Appointment</h2>
            <p className="text-white/90 max-w-2xl mx-auto">
              Your heart health is our top priority. Book an appointment today with Hyderabad's trusted experts at MAMS Hospitals
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <Phone className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Call Us</h3>
                <a href="tel:+917399999981" className="text-white/90 hover:text-white">
                  +91-7399999981
                </a>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <Mail className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Email Us</h3>
                <a href="mailto: info@mamshospitals.com" className="text-white/90 hover:text-white">
                   info@mamshospitals.com
                </a>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <MapPin className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Visit Us</h3>
                <p className="text-white/90">Bachupally, Miyapur</p>
              </CardContent>
            </Card>
          </div>

          <div className="text-center">
            {/* <Link href="/book-appointment">
              <Button size="lg" variant="secondary" className="rounded-full">
                <Calendar className="mr-2 h-5 w-5" />
                Schedule Your Appointment
              </Button>
            </Link> */}
          </div>
        </div>
      </section>

      {/* Emergency Banner */}
      <section className="py-8 px-0 bg-red-600 text-white">
        <div className="container mx-auto max-w-6xl">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <Clock className="h-8 w-8" />
              <div>
                <h3 className="text-xl font-bold">24/7 Emergency Care</h3>
                <p className="text-white/90">Fully equipped emergency department</p>
              </div>
            </div>
            <a href="tel:+917399999981">
              <Button size="lg" variant="secondary" className="w-full sm:w-auto rounded-full bg-white text-red-600 hover:bg-gray-100">
                <Phone className="mr-2 h-5 w-5" />
                Call Emergency
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
    </>
  );
}
